/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * PostHog API - 1 ops
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod'

export const PropertyOperator = /* @__PURE__ */ zod.enum([
    'exact',
    'is_not',
    'icontains',
    'not_icontains',
    'regex',
    'not_regex',
    'gt',
    'gte',
    'lt',
    'lte',
    'is_set',
    'is_not_set',
    'is_date_exact',
    'is_date_before',
    'is_date_after',
    'between',
    'not_between',
    'min',
    'max',
    'in',
    'not_in',
    'is_cleaned_path_exact',
    'flag_evaluates_to',
    'semver_eq',
    'semver_neq',
    'semver_gt',
    'semver_gte',
    'semver_lt',
    'semver_lte',
    'semver_tilde',
    'semver_caret',
    'semver_wildcard',
    'icontains_multi',
    'not_icontains_multi',
])

export type PropertyOperator = zod.input<typeof PropertyOperator>
export type PropertyOperatorOutput = zod.output<typeof PropertyOperator>
